/* eslint-disable */
// @ts-nocheck
import { createVNode } from 'vue';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { LegacyButtonType } from 'ant-design-vue/lib/button/buttonTypes';

export interface ModalParams {
  okType: LegacyButtonType,
  title: string,
  content: string,
  cancelText: string,
  centered: boolean,
  okText: string,
}
export function ModalToast(params:ModalParams) {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: params.title,
      icon: createVNode(ExclamationCircleOutlined),
      content: params.content,
      cancelText: params.cancelText,
      centered: params.centered,
      okText: params.okText,
      okType: params.okType ,
      onOk() {
        resolve('ok');
      },
      onCancel() {
        reject(new Error('cancel'));
      },
    });
  });
}

export function dosomeThing() {
  console.log('do something ');
}
